import axios from "axios";
import { Base_URL } from "../url";

export const fetchCountries = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CountryMaster/GetAllCountries`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching countries!";
  }
};

export const downloadCountriesExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/CountryMaster/DownloadCountriesExcel`,
      {},
      {
        responseType: "blob", // Required for file download
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading countries Excel!";
  }
};
